import { useAbility } from "@/casl-provider";
import { userStore } from "@/store/user-store";
import { getRelocationOrderDetailAccess } from "../_helpers/get-relocation-order-detail-access";

export function useRelocationOrderDetailAccess() {
  const ability = useAbility();
  const roles = userStore((state) => state.user?.roles);

  return getRelocationOrderDetailAccess(roles ?? [], ability);
}
